import { render, staticRenderFns } from "./VDocumentLogbook.vue?vue&type=template&id=18f9b590"
import script from "./VDocumentLogbook.vue?vue&type=script&lang=js"
export * from "./VDocumentLogbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports